/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import Accordion from '../../Components/AccordionLight';
import NavBarVertical from '../../Components/NavBarVertical';
import NavBarMobile from '../../Components/NavBarMobile';

class Profile01 extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta key="og:title" property="og:title" content="EDvice" />
          <meta key="description" name="description" content="EDvice" />
          <meta key="og:description" property="og:description" content="EDvice" />
        </Head>
        <Navbar>Navbar</Navbar>
        {/* <img alt="Research" src={require('./laptop-image.png')} /> */}
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="content-inner">
                <div className="profile-format-content">
                  <img alt="Research" src={require('./science01.png')} />
                  <div>
                    <h1>Dr Nick Saville</h1>
                    <p>Research and Thought Leadership Director</p>
                  </div>
                </div>
                <p>
                  Dr Nick Saville has worked for Cambridge Assessment since 1987, becoming Director
                  of the newly formed Research and Thought Leadership Division in 2015. Prior to
                  moving to Cambridge he worked at the University of Cagliari (Facoltà di Magistero)
                  teaching English, and managed a test development project for Cambridge English in
                  Tokyo based at the British Council. He holds a PhD in Language Assessment from the
                  University of Bedfordshire, a degree in Linguistics and an MA TEFL (both from the
                  University of Reading), and an MA Cantab.
                </p>
                <div className="profile__section">
                  <Accordion>
                    <div label="When did you become involved in Linguaskill?">
                      <h3>When did you become involved in Linguaskill?</h3>
                      <p>
                        The origins of Linguaskill go back to the mid-1990s when we began working on
                        the idea of online, automated, modular tests. The aim was to democratise
                        testing, making it quicker and more efficient. Since then Linguaskill has
                        developed to provide a generic, multilevel test that serves the needs of all
                        audiences, from education to business.
                      </p>
                    </div>
                    <div label="What makes Linguaskill different from other tests?">
                      <h3>What makes Linguaskill different from other tests?</h3>
                      <p>
                        Linguaskill is used to measure what has been learned, as opposed to
                        score-driven alternatives, which can measure how well you have practised for
                        the test. This means it is much more consistent and mission specific across
                        the four skills of listening, reading, writing and speaking.
                      </p>
                    </div>
                    <div label="What have you learned when developing Linguaskill?">
                      <h3>What have you learned when developing Linguaskill?</h3>
                      <p>
                        That ease of use is key. Many of the features within it, such as computer
                        assisted testing, automated writing and automated speaking testing are not
                        necessarily new to us at Cambridge Assessment English, but we’ve learned how
                        to deploy them in ways that are simple to administer, and can scale to
                        hundreds of thousands of people, reliably and seamlessly.
                      </p>
                    </div>
                    <div label="How do you see Linguaskill developing over the next 2–3 years?">
                      <h3>How do you see Linguaskill developing over the next 2–3 years?</h3>
                      <p>
                        It is clearly early days for the product – we have successfully launched it,
                        and we have created a stable and reliable platform. The holy grail of
                        language testing is being able to personalise tests for each client group,
                        so that they measure what matters to them. Through Linguaskill’s flexibility
                        we are able to move towards this personalisation, so we now have to work
                        with our partners and customers to develop and modify it to meet individual
                        needs.
                      </p>
                    </div>
                    <div label="How do you see computer-based testing changing in the future, particularly with the use of artificial intelligence (AI)?">
                      <h3>
                        How do you see computer-based testing changing in the future, particularly
                        with the use of artificial intelligence (AI)?
                      </h3>
                      <p>
                        AI will help close the gap between the actual situations where we use
                        language and the context of taking a test. Test conditions are not real
                        life, so the ideal for language testing is being able to observe people
                        doing the real thing, creating much more specific tests, personalised to
                        them. AI can assist here, particularly when coupled with the mobile devices
                        we all carry around with us. First-generation testing technology just
                        migrated tests from pen and paper – AI lets you go much further and deliver
                        more adaptive, personalised and efficient testing.
                      </p>
                    </div>
                    <div label="Are there other key trends that you see impacting language learning and testing over the next five years?">
                      <h3>
                        Are there other key trends that you see impacting language learning and
                        testing over the next five years?
                      </h3>
                      <p>
                        I see two key trends. Firstly, merging language testing into learning, so
                        that you can see how people perform in a real-world context will give a
                        greater richness, delivered in a more effective way.
                      </p>
                      <p>
                        Secondly, use of AI means we’re going to see a virtuous combination of
                        teachers and machines. We will always need teachers to provide human
                        guidance and support, but we can use the robotic strengths of machines to
                        help them deliver more effective learning. For example, if you have a class
                        of 40 people, a teacher clearly can’t mark 40 writing tasks every day. A
                        computer can. The teacher can then look at the analytics and enhance content
                        and support either for the whole class or at an individual level, improving
                        learning outcomes.
                      </p>
                    </div>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default Profile01;
